import React, { Children } from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const reasons = ['Contar hasta diez es imposible cuando tu cerebro ya está secuestrado por el enojo.', 'Intentar técnicas de "meditación profunda" no sirve de nada en mitad del tráfico de la 95 o mientras preparas loncheras.', 'Seguir consejos de expertos que no entienden la realidad de la mujer latina en USA aumenta tu sensación de fracaso.', 'Esperar a que "ellos cambien" primero te quita el poder de transformar tu propio hogar.'];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export const WhyFailed = () => {
  return <Section className="bg-beige/30" data-id="element-201">
      <div className="text-center mb-12" data-id="element-202">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-203">
          Por qué lo que has intentado no funciona
        </h2>
        <p className="text-lg text-charcoal/70 max-w-2xl mx-auto" data-id="element-204">
          No es tu culpa. Las herramientas tradicionales no están diseñadas para
          tu nivel de estrés diario.
        </p>
      </div>

      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-205">
        {reasons.map((reason, index) => <motion.div key={index} variants={item} className="bg-white p-6 md:p-8 rounded-2xl shadow-soft flex items-start gap-4" data-id="element-206">
            <XCircle className="text-terracotta shrink-0 mt-1" size={24} data-id="element-207" />
            <p className="text-charcoal/80 text-lg leading-relaxed" data-id="element-208">{reason}</p>
          </motion.div>)}
      </motion.div>
    </Section>;
};